
























import { Component, Vue } from 'vue-property-decorator';
import cDatagrid from '@/components/default/Datagrid.vue';
import cCard from '@/components/default/Card.vue';
import dashboardsRepository from '@/services/varia/dashboardsRepository';
import notificationService from '@/services/notificationService';

@Component({
  components: {
    cDatagrid,
    cCard,
  },
})
export default class DashboardsOverview extends Vue {
  private dashboards: IDashboardListItemDto[] = [];
  private loading: boolean = true;
  private saving: boolean = false;

  public mounted() {
    this.loadData();
  }

  public addingRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        const data: IDashboardCreateDto = {
          name: '',
          public: false,
        };

        Object.assign(data, e.data);

        const result = await dashboardsRepository.create(data);

        e.data = result.data;
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        reject('Failed to create dashboard');
      }
    });
  }

  public deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await dashboardsRepository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        reject('Failed to delete dashboard');
      }
    });
  }

  public isMyDashboard(e: any) {
    if (e && e.row && e.row.data.owner === this.currentUserId) {
      return true;
    }
    return false;
  }

  public updateRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        const data: any = {};
        Object.assign(data, e.oldData, e.newData);
        await dashboardsRepository.updateBasics(data);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        reject('Failed to update dashboard');
      }
    });
  }

  public openDetails(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons'
      && e.column.type !== 'selection') {
        this.$router.push({ path: `/dashboards/${e.row.data.id}` });
    }
  }

  public async loadData() {
    try {
      this.loading = true;
      this.dashboards = (await dashboardsRepository.get()).data;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  public addRow() {
    this.GridInstance.addRow();
  }

  get GridInstance() {
    return ((this.$refs.grid as Vue).$refs.dashboardsTable as any).instance;
  }

  get currentUserId() {
    const currentUser = this.$store.getters.currentUser;

    if (currentUser) {
      return currentUser.accountIdentifier;
    }

    return '';
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: 'name',
        caption: 'Naam',
      },
      {
        dataField: 'owner',
        caption: 'Eigenaar',
        lookup: {
          dataSource: this.$store.getters['employees/items'],
          displayExpr: 'displayName',
          valueExpr: 'id',
        },
        allowEditing: false,
      },
      {
        dataField: 'public',
        caption: 'Publiek',
        dataType: 'boolean',
      },
      {
        type: 'buttons',
        buttons: [
          'edit',
          'delete',
        ],
      },
    ];
  }
}
